<template>
  <span>
    <div
      class="kbx-content"
      klickbox-edit-item="progress"
      :klickbox-edit-label="$t('edit.canvas.progressbar')">
      <items></items>
    </div>
  </span>
</template>

<script>
import { mapActions } from 'vuex';
import Items from './Items';

export default {
  methods: mapActions([
    'canvasEnableHighlight',
  ]),
  components: {
    Items,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?b7b53a84
 **/